import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { ellipsisify } from "../../../Library/helpers";

const WidgetLegend = ({ data, parser, showCount = true, showPercent = true, doSort = true, ellipsify = true }) => {
  const formattedData = useMemo(() => {
    function addPercent(data){
      const total = data.reduce((accumulator, value) => (accumulator + value[parser.y]), 0);
      return data.map((d) => ({ ...d, percent: (((d[parser.y] / total) * 100) || 0).toFixed(0) }));
    }
    if (doSort){
      let sortedData = [...data].sort((a, b) => b[parser.y] - a[parser.y]);
      return addPercent(sortedData);
    }
    else
      return showPercent ? addPercent(data) : data;
  }, [data, doSort, parser.y, showPercent]);

  return (
    formattedData.map((row, index) => (
      <div className={"donut-row"} key={index}>
        <span className="donut-row-color" style={{ background: row.color }} />
        <span className="donut-row-label">{ellipsify ? ellipsisify(row[parser.x], 16) : row[parser.x]}</span>
        { showPercent && <span className="donut-row-stat">{row.percent}%</span> }
        { showCount && <span className="donut-row-value">{row[parser.y]}</span> }
      </div>
    ))
  );
};

WidgetLegend.propTypes = {
  data: PropTypes.array,
  parser: PropTypes.shape({ x: PropTypes.string, y: PropTypes.string }),
};

export default WidgetLegend;
